import { type UseQueryResult, useQuery } from 'react-query';
import {
  DynamicSchemaService,
  Wealthlane_AdministrationService_Dtos_DynamicUISchema_SchemaResponseDto,
} from '@wealthlane/api-services/wealthlane-administration-service';

const useGetSchemaByIdentifier = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  identifier: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AdministrationService_Dtos_DynamicUISchema_SchemaResponseDto | undefined,
  unknown
> => {
  return useQuery(['useGetSchemaByIdentifier', identifier], async () => {
    return await handleRequest(
      DynamicSchemaService.getApiAdministrationApiAppDynamicSchemaSchemaDetailsByIdentifier(
        identifier
      )
    );
  });
};

export default useGetSchemaByIdentifier;
